<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-menu
            v-model="startCal"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mt-5 pt-5 pr-5"
                style="max-width:215px"
                placeholder="From"
                v-model="dateFilter.startDate"
                append-icon="event"
                readonly
                clearable
                @click:clear="dateFilter.startDate = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              type="month"
              v-model="dateFilter.startDate"
              @input="startCal = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            v-model="endCal"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mt-5 pt-5 pr-5"
                style="max-width:215px"
                placeholder="To"
                v-model="dateFilter.endDate"
                append-icon="event"
                readonly
                clearable
                @click:clear="dateFilter.endDate = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              type="month"
              v-model="dateFilter.endDate"
              @input="endCal = false"
            ></v-date-picker>
          </v-menu>
          <v-text-field class="btn-search" v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
          <v-btn class="btn-chevron" text @click="$emit('changeMonth', 'previous')" :disabled="disableLeftArrow">
            <v-icon style="font-size:22px">mdi-chevron-left-circle</v-icon>
          </v-btn>
          <v-btn class="btn-chevron" text @click="$emit('changeMonth', 'next')" :disabled="disableRightArrow">
            <v-icon style="font-size:22px">mdi-chevron-right-circle</v-icon>
          </v-btn>
        </v-card-title>
      </v-col>
    </v-row>
    <!-- BEGIN Calendar table -->
    <v-data-table
      :headers="headers"
      :search="filter"
      :items="filteredItems"
      class="table-calendar elevation-1"
      :loading="loading">
      <template v-slot:[`item.poc`]="{ item }">
        <td class="text-left">
          {{item.poc}}
        </td>
      </template>
      <template v-slot:[`item.bfs`]="{ item }">
        <td class="text-start">
          <v-btn
            small
            text
            color="secondary"
            elevation="0"
            :to="'/client/brand-fact-sheet?id='+item.bfs"
            :target="'_blank'"
            v-if="item.bfs"
          >
            View BFS
          </v-btn>
        </td>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <td class="text-left">
          {{item.name}}
        </td>
      </template>
      <template v-slot:[`item.${month}`]="{ item }" v-for="month in calendarMonths">
        <td 
        class="text-center"
        :style="`background-color:${item.bgColor};opacity:0.8`"
        v-if="item[month] || item[month] === 0">
          <div class="text-inside">{{item[month]}}</div>
        </td>
        <td class="text-center" v-else>
          {{item[month]}}
        </td>
      </template>
    </v-data-table>
    <!-- End Calendar table -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
// import utils from '@/utils';
import Loading from 'vue-loading-overlay';
// import moment from 'moment'
// import campaignAPIs from '../campaignAPIs';
export default {
  name: 'CalendarTable',
  components: {
    Loading
  },
  props: [
    'headers',
    'calendarMonths',
    'filteredItems',
    'filter',
    'loading',
    'disableLeftArrow',
    'disableRightArrow'
  ],
  data () {
    return {
      disableSave: true,
      isLoading: false,
      dateFilter: {
        startDate: null,
        endDate: null
      }
    }
  },
  watch: {
    dateFilter: {
      handler: function (val, oldVal) {
        this.$emit('filterDate', this.dateFilter)
      },
      deep: true
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>
  .table-calendar tbody td {
    border-right: 1px solid #dddddd;
    height: 100px!important;
  }
</style>
<style scoped>
  .btn-search {
    max-width: 500px;
    padding-right: 30px;
  }
  .btn-chevron {
    min-width: 35px!important;
    margin: 0!important;
    padding: 0!important;
  }
  .text-inside {
    display: inline;
    background: #fff;
    margin: auto;
    font-weight: bold;
    padding: 5px;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// CalendarTable.vue?60ec8409